"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ControllerContainer = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.ControllerContainer = styled_components_1.default.div `
  padding-left: 5px;
  padding-right: 5px;
`;
//# sourceMappingURL=elements.js.map